
/* injects from baggage-loader */

import React from 'react';
import {Route, IndexRoute, Router} from "react-router";
import Layout from "../../../../dev/terminal/containers/layout";
import Live from "../../../../dev/terminal/containers/live";
import GameWrapperWrapper from '../../../../dev/terminal/containers/gameWrapperWrapper';
import Prematch from "../../../../dev/terminal/containers/prematch";
import Today from "../../../../dev/terminal/containers/today";
import Home2 from "../../../../dev/terminal/containers/home2";
import ErrorNotFoundPage from "../../../../dev/terminal/components/errorNotFoundPage";
import VirtualGames from "../../../../dev/terminal/containers/virtualGames";
import Casino from "../../../../dev/terminal/containers/casino";
import LiveCasino from "../../../../dev/terminal/containers/liveCasino";
import AdminWrapper from '../../../../dev/terminal/containers/adminWrapper'
import Result from '../../../../dev/terminal/containers/result';
import CasinoFavorites from '../../../../dev/terminal/containers/casino/components/favorites';
import Tournaments from '@app/dev/terminal/containers/tournaments';
import TournamentDetails from '@app/dev/terminal/containers/tournaments/components/details';
import ThirdPartyGame from '../../../../dev/terminal/containers/thirdPartyGame';

const history = require("history").createBrowserHistory({
    basename: '/base'
});

export const routerBuilder = (store) => (
    <Router history={history}>
        <Route path="/" component={Layout}>
            <IndexRoute component={Home2}/>
            <Route path="live">
                <IndexRoute component={Live}/>
                <Route path="(:sportAlias)" component={Live}/>
                <Route path="(:sportAlias/:regionId)" component={Live}/>
                <Route path="(:sportAlias/:regionId/:competitionId)" component={Live}>
                    <Route path="(:gameId)" component={GameWrapperWrapper}/>
                </Route>
            </Route>
            <Route path="prematch">
                <IndexRoute component={Prematch}/>
                <Route path="(:sportAlias)" component={Prematch}/>
                <Route path="(:sportAlias/:regionId)" component={Prematch}/>
                <Route path="(:sportAlias/:regionId/:competitionId)" component={Prematch}>
                    <Route path="(:gameId)" component={GameWrapperWrapper}/>
                </Route>
            </Route>
            <Route path="today">
                <IndexRoute component={Today}/>
                <Route path="(:sportAlias)" component={Today}/>
                <Route path="(:sportAlias/:regionId)" component={Today}/>
                <Route path="(:sportAlias/:regionId/:competitionId)" component={Today}>
                    <Route path="(:gameId)" component={GameWrapperWrapper}/>
                </Route>
            </Route>
            <Route path="thirdPartyGame">
                <IndexRoute component={ThirdPartyGame}/>
                <Route path="(:id)" component={ThirdPartyGame}/>
            </Route>
            <Route path="casino">
                <IndexRoute component={Casino}/>
                <Route path="favorites" component={CasinoFavorites}/>
            </Route>
            <Route path="tournaments">
                <IndexRoute component={Tournaments}/>
                <Route path=":id" component={TournamentDetails}/>
            </Route>
            <Route path="dealer">
                <IndexRoute component={LiveCasino}/>
            </Route>
            <Route path="result">
                <IndexRoute component={Result}/>
            </Route>
            <Route path="virtualGames">
                <IndexRoute component={VirtualGames}/>
            </Route>
            <Route path="admin">
                <IndexRoute component={AdminWrapper}/>
            </Route>
            <Route path="*" component={ErrorNotFoundPage}/>
        </Route>
    </Router>
);